/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@material-ui/core';
import { useFormik } from 'formik';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { migrateCustomerInitialState } from '../../constants/migrateCustomer';
import useCurrentUser from '../../hooks/useCurrentUser';
import { Business } from '../../models/User.model';
import ButtonField from '../../reusable/ButtonField';
import { TextFieldComponent } from '../../reusable/TextFieldComponent';
import { faliedMigrateCustomer } from '../../services/failedMigrateCustomer.service';
import migrateCustomersService from '../../services/migrateCustomers.service';
import { toastMessageAction } from '../../store/action';
import { migrateCusotmerToSchema } from '../../validation/migrateCusotmerToSchema';
import TableBodyLoader from '../Campaign/shared/components/TableBodyLoader/TableBodyLoader';
import TableHeader from '../Campaign/shared/components/TableHeader/TableHeader';
import classes from './index.module.scss';

const MigrateCustomer = () => {
  const [business, setBusiness] = useState(new Business());
  const [isFetching, setIsFetching] = useState(true);
  const [migrate, setMigrate] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [buttonText, setButtonText] = useState('Migrate');
  const dispatch = useDispatch();
  const user = useCurrentUser();
  // const dispatch = useDispatch();
  //handle business change

  const migration = async () => {
    const migratedData = await faliedMigrateCustomer();
    if (migratedData.length) {
      setMigrate(migratedData);
    }
    setIsFetching(false);
  };

  useEffect(() => {
    if (user.id) {
      migration();
    }
  }, [user, isSubmit]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paramsBuId = _.parseInt(urlParams.get('bu'));
    const paramsBusiness = _(user.getBusinesses()).find(
      b => b.id === paramsBuId
    );
    if (paramsBusiness) setBusiness(paramsBusiness);
  }, [user]);

  //to handle form submit
  const onSubmit = async (workData, { resetForm }) => {
    setDisableSubmit(true);
    const saveMigrate = await migrateCustomersService.saveMigrateCustomers(
      workData,
      business.id
    );
    // toast.promise(saveMigrate, {
    //   pending: 'Processing...',
    //   theme: 'dark'
    // });
    if (Object.keys(saveMigrate).length === 0) {
      dispatch(
        toastMessageAction({
          severity: 'error',
          message: 'DB error Remigrate',
          messageStatus: true
        })
      );
      setButtonText('Remigrate');
    }
    if (saveMigrate.status === 'failure') {
      dispatch(
        toastMessageAction({
          severity: 'error',
          message: saveMigrate.errors[0].errorType,
          messageStatus: true
        })
      );
    }
    if (saveMigrate.status === 'success') {
      const { data } = saveMigrate;
      data
        ? toast.error(data.errors[0].errorType)
        : toast.success('migrate successfully completed');

      !data && resetForm();
      setButtonText('Migrate');
    }
    setIsSubmit(!isSubmit);
    setDisableSubmit(false);
  };

  const formik = useFormik({
    initialValues: migrateCustomerInitialState,
    validationSchema: migrateCusotmerToSchema,
    onSubmit
  });
  const { values, errors, touched, handleChange, resetForm } = formik;

  //to handle close button
  const handleClose = () => {
    resetForm();
  };
  return (
    <div>
      <div className={classes.alignContainer}>
        <div className={classes.businessUnitStyle}>
          <div>
            <div className={classes.headerTitle}>Customer Migrate</div>
            <p>Migrate customer from old mobile number to new mobile number</p>
          </div>
        </div>
      </div>
      <div className={classes.alignContainer}>
        <Paper className={classes.migrateModalContainer} elevation={2}>
          <form
            onSubmit={formik.handleSubmit}
            className={classes.formContainer}
          >
            <div className={classes.formField}>
              <TextFieldComponent
                label={'Old Mobile number*'}
                name={'oldMobileNumber'}
                onChange={handleChange}
                value={values.oldMobileNumber}
                error={touched.oldMobileNumber && errors.oldMobileNumber}
                type="number"
              />
              <TextFieldComponent
                label={'New mobile number*'}
                name={'newMobileNumber'}
                onChange={handleChange}
                value={values.newMobileNumber}
                error={touched.newMobileNumber && errors.newMobileNumber}
                type="number"
              />
            </div>
            {/* <div style={{ marginTop: 30 }}>
            <PurpleSwitch checked={true} />
            <span>Migrate Loyalty</span>
            <PurpleSwitch checked={true} />
            <span>Migrate NPS</span>
            <PurpleSwitch checked={true} />
            <span>Migrate Offers</span>
          </div> */}
            <div className={classes.submitButton}>
              <ButtonField
                variant="contained"
                label={'Clear'}
                type="button"
                onClick={handleClose}
                style={{
                  color: '#F07663',
                  background: 'white',
                  marginRight: 15
                }}
              />
              <ButtonField
                variant="contained"
                label={buttonText}
                type="submit"
                style={{ background: '#F07663', color: 'white' }}
                disabled={disableSubmit}
              />
            </div>
          </form>
          <div className={classes.alignContainer}>
            <TableContainer
              className={classes.formField}
              style={{ height: migrate.length > 10 ? '600px' : 'auto' }}
            >
              <Table>
                <TableHeader
                  headers={['Old Number', 'New Number', 'Status']}
                  textAlign="center"
                />
                {isFetching ? (
                  <TableBodyLoader rowsPerPage={10} colSpan={3} />
                ) : (
                  <TableBody className={classes.tableBody}>
                    {migrate.map((customer, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">
                          {customer.fromMobile}
                        </TableCell>
                        <TableCell align="center">
                          {customer.toMobile}
                        </TableCell>
                        <TableCell align="center">
                          {customer.externalSyncDone
                            ? 'Complete'
                            : 'Incomplete'}
                        </TableCell>
                      </TableRow>
                    ))}
                    {!migrate.length && (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          No Data found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </div>
        </Paper>
      </div>
    </div>
  );
};

export default MigrateCustomer;
